<template>
  <div class="calendar">
    <div class="calendar-header d-flex justify-content-between px-2">
      <a href="" @click.prevent="prevMonth" class="calendar-header-nav p-2">
        <span class="fa-solid fa-chevron-left"></span>
      </a>
      <div>{{ monthName }} {{ year }}</div>
      <a href="" @click.prevent="nextMonth" class="calendar-header-nav p-2">
        <span class="fa-solid fa-chevron-right"></span>
      </a>
    </div>
    <div class="calendar-grid">
      <!-- Render day headers -->
      <div v-for="day in dayHeaders" :key="day" class="calendar-day-header">
        {{ day }}
      </div>

      <!-- Render blank days for alignment -->
      <div v-for="n in firstDayOfWeek" :key="'empty-' + n" class="calendar-day empty"></div>

      <!-- Render actual days -->
      <div v-for="day in days" :key="day.date" :class="`calendar-day ${cellClass(day)}`"
           :title="getTooltip(day)" data-bs-toggle="tooltip" @click="selectDay(day)">
        <div>{{ day.day }}</div>
      </div>
    </div>
    <div class="border-top border-300">
      <a href="" class="mt-2 btn btn-ssnet btn-sm" @click.prevent="selectToday">Danas</a>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    month: {
      type: Number,
      required: true,
    },
    year: {
      type: Number,
      required: true
    },
    dayClass: Function,
    dayTooltip: Function,
  },
  data() {
    return {
      currentMonth: this.month,
      currentYear: this.year
    };
  },
  mounted() {
    this.emitChanged()
    this.$nextTick(() => {
      this.attachTooltips()
    })
  },
  computed: {
    monthName() {
      let months = ['Januar', 'Februar', 'Mart', 'April', 'Maj',
      'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar']
      return months[this.currentMonth-1];
    },
    dayHeaders() {
      return ['Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub', 'Ned'];
    },
    firstDayOfWeek() {
      const firstDay = new Date(this.currentYear, this.currentMonth - 1, 1).getDay();

      // Adjust to make Monday the first day of the week
      return firstDay === 0 ? 6 : firstDay - 1;
    },
    days() {
      const days = [];
      const daysInMonth = new Date(this.currentYear, this.currentMonth, 0).getDate();

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(this.currentYear, this.currentMonth - 1, day+1);

        // Adjust weekday calculation to make Monday the first day of the week
        let weekday = date.getDay(); // Default: 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        weekday = (weekday === 0) ? 6 : weekday - 1; // Convert Sunday (0) to 6, and shift other days

        days.push({
          day,
          weekday, // Now this will be 0 = Monday, 1 = Tuesday, ..., 6 = Sunday
          date: date.toISOString().split('T')[0]
        });
      }

      return days;
    }
  },
  methods: {
    emitChanged() {
      this.$emit('change', {year: this.currentYear, month: this.currentMonth});
    },
    prevMonth(event) {
      event.stopPropagation();
      if (this.currentMonth === 1) {
        this.currentMonth = 12;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
      this.attachTooltips()
      this.emitChanged()
    },
    nextMonth(event) {
      event.stopPropagation();
      if (this.currentMonth === 12) {
        this.currentMonth = 1;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
      this.attachTooltips()
      this.emitChanged()
    },
    cellClass(day) {
      let s=''
      if(typeof this.dayClass === 'function') {
        s = this.dayClass(day) ?? ''
      }
      if(day.date == moment().format('YYYY-MM-DD')) {
        s+=' today'
      }
      return s
    },
    getTooltip(day) {
      if(typeof this.dayTooltip === 'function') {
        return this.dayTooltip(day);
      }
    },
    attachTooltips() {
      setTimeout(()=>{
        const tooltipTriggerList = [].slice.call(this.$el.parentNode.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.forEach(el => {
          new bootstrap.Tooltip(el);
        })
      },500)
    },
    selectDay(day) {
      this.$emit('selectDay', day);
    },
    selectToday() {
      this.$emit('selectDay', {date:moment().format('YYYY-MM-DD')});
    }
  }
}
</script>

<style scoped>

</style>
